<template>
  <div class="container" v-if="userInfo">
    <div class="title">基本信息</div>

    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">昵称：</Col>
      <Col span="14" class="avatar-wrap">
        <Input v-model="userInfo.user.nickname" placeholder="请填写昵称" style="width: 200px" maxlength="20"/>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">姓名：</Col>
      <Col span="14" class="avatar-wrap">
        <Input v-model="userInfo.user.name" placeholder="请填写姓名" style="width: 200px" maxlength="20"/>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">头像：</Col>
      <Col span="14">
        <Upload
          ref="upload"
          type="drag"
          :headers="$uploader.headers()"
          :action="$uploader.action"
          :show-upload-list="false"
          :on-success="uploadSuccess"
          :format="['jpg', 'jpeg', 'png']"
          :before-upload="$uploader.beforeUpload"
          style="width:58px;"
        >
          <div style="width: 58px; height: 58px; line-height: 58px">
            <img style="width: 58px; height: 58px; line-height: 58px" v-if="userInfo && userInfo.user && userInfo.user.avatarUrl" :src="userInfo.user.avatarUrl" />
            <Icon v-else type="shangchuantupian1" :size="20"></Icon>
          </div>
        </Upload>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">性别：</Col>
      <Col span="14">
        <Select v-model="userInfo.user.gender" style="width: 200px">
          <Option v-for="item in sexArray" :value="item" :key="item">{{ item }}</Option>
        </Select>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">手机号：</Col>
      <Col span="14">
        <div>
          {{ userInfo.user.mobileMask }}
        </div>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">我的公司：</Col>
      <Col span="14">
        <div class="item-value">{{userInfo && userInfo.company&& userInfo.company.name}}</div>
      </Col>
    </Row>
    <Row class="item-wrap margin-bottom20" type="flex" align="middle">
      <Col span="10" class="item-title">我的职务：</Col>
      <Col span="14" v-if="userInfo ">
        <Input v-model="userInfo.duty" placeholder="请填写职务" style="width: 200px" maxlength="20"/>
      </Col>
    </Row>
    
    <div class="btn-wrap">
      <Button type="primary" @click="doSubmit">保存</Button>
    </div>
  </div>
</template>

<script>
var maxsize = 1024 * 1024 * 8; // 最大8MB
export default {
  data() {
    return {
      userInfo: null,
      sexArray: ['男', '女'],
      params: {
        parent: 0, // 父文件 (当前目录)
        sort: 'uploaded', // 排序字段
        asc: false // 是否正序
      },
      token: null,
      domain: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    uploadSuccess(res) {
      this.userInfo.user.avatarUrl = res.data.url;
    },
    init() {
      this.$axios
        .request({
          url: 'front/v1/company-user/myInfo'
        })
        .then(res => {
          this.userInfo = res.data;
        });
    },
    
    doSubmit() {
      this.$axios.request({
        url: 'front/v1/user/updateInfo',
        method: 'PUT',
        data: {
          nickname: this.userInfo.user.nickname,
          gender: this.userInfo.user.gender,
          avatarUrl: this.userInfo.user.avatarUrl,
          name:this.userInfo.user.name
        }
      });
      this.$axios
        .request({
          url: 'front/v1/company-user/' + this.userInfo.id,
          method: 'PUT',
          data: {
            duty: this.userInfo.duty
          }
        })
        .then(res => {
          this.$Notice.success({
            title: res.msg
          });
          setTimeout(() => {
            this.$router.back(-1);
          }, 500);
        });
      // this.$axios
      //   .request({
      //     url: 'api/qiye/updateUserInfo',
      //     method: 'post',
      //     data: this.userInfo
      //   })
      //   .then(res => {
      //     if (res.success) {
      //       this.$Notice.success({
      //         title: '更新成功'
      //       });
      //       this.getUserInfo();
      //       setTimeout(() => {
      //         this.$router.back(-1);
      //       }, 500);
      //       // store.commit("updateUserProfile", res.data);

      //       // this.$router.back();
      //     }
      //   });
    },
    getUserInfo() {
      this.$axios.request({ url: 'api/common/userinfo' }).then(res => {
        this.$store.commit('updateUserProfile', res.data);
        // if (res.data) {
        //   tim.updateMyProfile({
        //     nick: res.data.name,
        //     avatar: res.data.avatar
        //   });
        // }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 40px 0;
  .editor-wrapper {
    width: 350px;
  }
}
.title {
  padding-left: 420px;
  color: #363e4f;
  font-size: 16px;
  margin-bottom: 20px;
}
.item-wrap {
  .item-title {
    text-align: right;
    padding-right: 10px;
  }
  .tips {
    font-size: 12px;
    margin-top: 10px;
  }
  img {
    width: 96px;
    height: 96px;
    cursor: pointer;
  }
  /deep/ .fileinput-btn {
    padding: 5px 22px;
    .ivu-icon {
      font-size: 30px;
    }
  }
}
.margin-bottom20 {
  margin-bottom: 20px;
}
.btn-wrap {
  padding-left: 756px;
}
.margin-left10 {
  margin-left: 10px;
}
.avatar-wrap {
  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
}
</style>
